import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import { BasicModalComponent } from "./basic-modal.component";
import {FileUploadModule} from 'ng2-file-upload';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgCircleProgressModule } from "ng-circle-progress";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
    declarations: [BasicModalComponent],
    imports     : [
        BrowserModule, 
        RouterModule, 
        NgSelectModule,
        ReactiveFormsModule,
        BsDropdownModule,
        FileUploadModule,
        NgCircleProgressModule,
        FormsModule
    ],
    exports     : [BasicModalComponent],
})

export class BasicModalModule {
   
    constructor(){
        
    }
}